import script from "./LinkedResidents.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkedResidents.vue?vue&type=script&setup=true&lang=ts"

import "./LinkedResidents.vue?vue&type=style&index=0&id=3bba17f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bba17f6"]])

export default __exports__